import React, { useCallback, useEffect } from 'react';

import { toUSD } from 'helpers/NumberFormats';
import useMartyContext from 'hooks/useMartyContext';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';
import Tooltip from 'components/common/Tooltip';
import { MoreInfo } from 'components/icons';

import styles from 'styles/components/search/sponsoredProducts.scss';

const SponsoredProducts = ({
  onHeartClick,
  showHearting,
  hearts,
  msaImageParams,
  showRatingStars,
  heartsList,
  heartsData,
  sponsoredProducts,
  searchTerm,
  trackSponsoredProductEvent
}) => {
  const { testId, marketplace: { shortName } } = useMartyContext();
  const additionalMelodyCardProductClasses = { container: styles.product };

  const handleSponsoredProductClick = useCallback(({ index, styleId, adId }) => {
    trackSponsoredProductEvent({ eventType: 'click', styleId, adId, searchTerm, index });
  }, [searchTerm, trackSponsoredProductEvent]);

  useEffect(() => {
    trackSponsoredProductEvent({ eventType: 'view', searchTerm });
  }, [searchTerm, trackSponsoredProductEvent]);

  return (
    <aside className={styles.searchSponsoredProductsContainer}>
      <h2 className={styles.title}>Sponsored Products</h2>
      <Tooltip
        content={`These are ads for products you'll find on ${shortName}.com. Clicking an ad will take you to the product's page.`}
        wrapperClassName={styles.tooltipWrapper}
        tooltipClassName={styles.tooltip}
        direction="down"
        sponsored={true}
        tooltipId="sponsoredProducts"
      >
        <MoreInfo />
      </Tooltip>
      <div className={styles.products}>
        {sponsoredProducts.styles.map((product, index) => {
          // Massage data for price formatting
          const cardData = {
            ...product,
            price: toUSD(product.price),
            originalPrice: toUSD(product.originalPrice),
            isSponsored: true
          };
          return (
            <MelodyCardProduct
              key={product.styleId}
              onComponentClick={() => handleSponsoredProductClick({ index, styleId: product.styleId, adId: sponsoredProducts.adId })}
              componentStyle="searchProductInlineRecos"
              heartsData={heartsData}
              showFavoriteHeart={showHearting}
              onHeartClick={onHeartClick}
              hearts={hearts}
              additionalClasses={additionalMelodyCardProductClasses}
              cardData={cardData}
              msaImageParams={msaImageParams}
              melodyCardTestId={testId('searchResultsSponsoredProducts')}
              showRatingStars={showRatingStars}
              heartsList={heartsList}
            />
          );
        }
        )}
      </div>
    </aside>
  );
};

export default SponsoredProducts;
